import StarOutlineRounded from "@mui/icons-material/StarOutlineRounded";
import StarRounded from "@mui/icons-material/StarRounded";
import { CustomViewItem } from "csi/middleware/customView/customViewLeftPanel/CustomViewItem";
import { yellow } from "designSystem/styles/color";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import IconButton, { IconButtonProps } from "../../../designSystem/components/button/IconButton";
import css from "./CustomViewFavoriteButton.module.css";
import clsx from "clsx";

export interface CustomViewFavoriteButtonProps extends IconButtonProps {
	/** custom view item */
	customViewItem: CustomViewItem;

	/** only show button when hovering */
	showOnHover?: boolean;
}

const CustomViewFavoriteButton: FunctionComponent<CustomViewFavoriteButtonProps> = observer((props) => {
	const {
		className,
		customViewItem,
		showOnHover,
		...otherProps
	} = props;
	const {
		isFavorite,
		isProcessingFavorite,
		onFavoriteButtonClick,
		showAddToFavorite,
		showRemoveFromFavorite,
	} = customViewItem;
	const tooltipRes = showAddToFavorite ? "CustomViewFavoritesAdd" : "CustomViewFavoritesRemove";

	if (showAddToFavorite || showRemoveFromFavorite) {
		return (
			<IconButton
				className={clsx(className, css.button)}
				disabled={isProcessingFavorite}
				onClick={onFavoriteButtonClick}
				res={tooltipRes}
				size="small"
				{...otherProps}
			>
				{isFavorite ? <StarRounded style={{ color: yellow[700] }} /> : <StarOutlineRounded />}
			</IconButton>
		);
	} else {
		return null;
	}
});

export default CustomViewFavoriteButton;